import brand from './brand.js';
import space from './space.js';
import service from './service.js';
export default [
  ...brand,
  ...space,
  ...service,
  {
    path: '/product/list',
    name: 'productList',
    component: function (resolve) {
      require(['@/pages/userPage/product/list'], resolve)
    }
  },
  {
    path: '/product/traceInfo',
    name: 'productTraceInfo',
    component: function (resolve) {
      require(['@/pages/userPage/product/traceInfo'], resolve)
    }
  },
  {
    path: '/product/create',
    name: 'productCreate',
    component: function (resolve) {
      require(['@/pages/userPage/product/create'], resolve)
    }
  },
  {
    path: '/product/detail',
    name: 'productDetail',
    component: function (resolve) {
      require(['@/pages/userPage/product/detail'], resolve)
    }
  },
  {
    path: '/shoppingMall/list',
    name: 'shoppingMallList',
    component: function (resolve) {
      require(['@/pages/userPage/shoppingMall/index'], resolve)
    }
  },
  {
    path: '/shoppingMall/order',
    name: 'shoppingMallorder',
    component: function (resolve) {
      require(['@/pages/userPage/shoppingMall/order'], resolve)
    }
  },
  {
    path: '/shoppingMall/detail',
    name: 'shoppingMallDetail',
    component: function (resolve) {
      require(['@/pages/userPage/shoppingMall/detail'], resolve)
    }
  },
  {
    path: '/marketing/list',
    name: 'marketingList',
    component: function (resolve) {
      require(['@/pages/userPage/marketing/index'], resolve)
    }
  },
  {
    path: '/marketing/createMoneyActivity',
    name: 'createMoneyActivity',
    component: function (resolve) {
      require(['@/pages/userPage/marketing/createMoneyActivity'], resolve)
    }
  },
  {
    path: '/marketing/createMessageActivity',
    name: 'createMessageActivity',
    component: function (resolve) {
      require(['@/pages/userPage/marketing/createMessageActivity'], resolve)
    }
  },
  {
    path: '/marketing/betchDetail',
    name: 'betchDetail',
    component: function (resolve) {
      require(['@/pages/userPage/marketing/betchDetail'], resolve)
    }
  },
  {
    path: '/user/survey',
    name: 'survey',
    component: function (resolve) {
      require(['@/pages/userPage/survey'], resolve)
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/userLayout/layoutChildren.js